import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useHasPermission } from '../hooks/useHasPermission';
import { Fleet, Permit } from '../interfaces';
import { RoadworksService } from '../services/roadworks.service';

const key = 'roadworks';

export const useRoadworkPermitQuery = (id: string, isEnabled: boolean) => {
  const queryKey = [key, id];
  const hasPermission = useHasPermission('roadworks:read:list');

  const queryFn = () => RoadworksService.getRoadworkPermit(id);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!id && hasPermission && isEnabled,
  });
};

export const useRoadworkPermitsQuery = (fleet: Fleet) => {
  const queryKey = [key, 'list', fleet.uuid];
  const isEnabled = useHasPermission('roadworks:read:list');

  const queryFn = () =>
    RoadworksService.getRoadworkPermits(
      { dateFrom: '1980-01-01T00:00:00.000Z', dateTo: '2099-12-31T23:59:59.999Z', limit: 99999 },
      fleet,
    );

  return useQuery({
    queryKey,
    queryFn,
    enabled: isEnabled,
  });
};

export const usePermitPreview = () => {
  return useQuery<Permit | null>({
    queryKey: [key, 'preview'],
    enabled: true,
    queryFn: () => null,
    staleTime: Infinity, // never stale
    cacheTime: Infinity, // never garbage collected
  });
};
